const getLetterByNumber = (index: number) => {
    const alphabetic = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";

    return alphabetic.split("")[index];
};

export default getLetterByNumber;
